import {store} from 'modules/store';
import {get} from 'lodash';

const trkGuid = "1f949c88-6f0c-47b6-a50c-3afc423e88dc";

export enum EventGUID {
	HOMEPAGE_LOAD = 'a8b27bb1-ec5f-42a3-ab9b-1e5577d2c336',
	GAMEPLAY_START = 'b2ec464a-33ae-48e3-a05d-1dcc59f5a12a',
	GAMEPLAY_COMPLETE = 'e266e081-a931-43c3-8427-b7f2b5a3e1c0',
	LEADERBOARD_PAGE_LOAD = '46ee1f70-b66a-4dcf-9ef7-8dd82bbe5ada',
	LEAGUES_PAGE_LOAD = 'b36c4141-b90a-4f88-8e74-13cf6fd01d56',
	CREATE_LEAGUES = '4480780b-224c-4673-aa4f-cb34bbdaef72',
	CREATE_LEAGUES_COMPLETE = 'e016ef27-88ec-4dd2-b4a1-87b0392407ad',
	JOIN_LEAGUES = '18b5a417-833b-4a57-8a71-76cb3a55c601',
	JOIN_LEAGUES_COMPLETE = '423c41a2-e7c4-417b-b816-6e4dab02aa85',
	LEAGUE_SELECT_IN_LEAGUES = 'f8b244b1-d175-44b5-a6f1-6e22cd3f0445',
	SHARE_IN_LEAGUES = '6617d09f-eeb2-4a09-bb78-118192957749',
	JOIN_LEAGUES_IN_LEAGUES = '3b86af5c-cf81-4751-ba1e-d9dd16a5c6cf',
	NAVIGATION_GAMEPLAY = '1e2ef072-681f-466d-b697-d95b9ac8312a',
	NAVIGATION_LEAGUES = 'db1a16bb-9606-449c-98e1-75efa37f9a11',
	NAVIGATION_LEADERBOARD = '322e8afe-f2fa-481d-94f3-a2016ea53503',
	NAVIGATION_HELP = '1f96e079-cf8f-44e9-9bac-8319c0a9899d',
	SPONSOR_CLICK = '335f5d33-7777-4652-a9f7-4073f2429fa8',
	HOMEPAGE_LEADERBOARD_CLICK = 'd00215c1-d218-456d-b94d-e7e4eb5e279e',
	UPDATE_PICK = '52760a23-10b2-4a11-a951-db87abb2e7af',
	POSTPICK_ADDITIONAL_PICK = '18401de6-05eb-474c-9a7b-c113583c4f70',
	POSTPICK_VIEW_LEADERBOARD = 'c2a2be1f-7396-48ef-9938-e3727dd2c264',
	OVERALL_LEADERBOARD = '8e179713-233b-40b0-85dd-815637fdb323',
	BTS_TO_POTG = '375ba3f2-85fe-4c76-94d6-7c3bba90ff65',
	BTS_TO_BTN = '79b4101d-4ec0-4b81-8a91-72abcddb68a6',
	BTS_TO_SPINBALL = '4196ef92-d156-48f9-bcff-6e522b61e226'
}

export const createFanHubEvent = (evtGuid: EventGUID) => {
	try {
		const allStore = store.getState();

		const clientUserId = String(get(allStore, "user.currentUser.id", null));
		const url = null;
		const d1 = null;
		const d2 = null;
		const d3 = null;
		const cnvValue = null;
		const cnvCurrency = null;
		const orderId = null;

		window.FanHub?.createEvent(
			evtGuid,
			trkGuid,
			url,
			d1,
			d2,
			d3,
			cnvValue,
			clientUserId,
			cnvCurrency,
			orderId
		);
	} catch (e) {
		console.error(e);
	}
};

export const createFanHubEventScriptTag = (evtGuid: EventGUID) => {
	const elementName = "script";
	const SCRIPT_ID = "fanhub-tagging";
	document.getElementById(SCRIPT_ID)?.remove();

	const src = `https://tag.fanhub.geniussports.com/js/evt.js`;
	const url = new URL(src);
	const script = document.createElement(elementName);
	const allStore = store.getState();

	const clientUserId = String(get(allStore, "user.currentUser.id", null));

	script.id = SCRIPT_ID;
	script.src = url.toString();
	script.async = true;
	script.setAttribute("data-trkGuid", trkGuid);
	script.setAttribute("data-evtGuid", evtGuid);
	if (clientUserId) {
		script.setAttribute("data-clientUserId", clientUserId);
	}

	const firstJS = document.getElementsByTagName(elementName)[0];
	firstJS.parentNode!.insertBefore(script, firstJS);

	return script;
};
